import { TEasTableInfoPannelStructure } from './EasTableInfoPannel';

export const gpsrAdditionalInformationStructure: TEasTableInfoPannelStructure[] = [
	{
		label: 'Subscription Plan',
		key: 'subscriptionPlan',
		type: 'text',
	},
	{
		label: 'Covered Product Types',
		key: 'coveredProductTypes',
		type: 'text',
	},
	{
		label: 'Valid Till',
		key: 'validTill',
		type: 'date',
	},
	{
		label: 'Service Status',
		key: 'serviceStatus',
		type: 'text',
		statuses: [
			['cancelled', ' Renewal cancelled'],
			['invoiced', 'Invoiced'],
		],
	},
	{
		label: 'Confirmation Status',
		key: 'confirmationStatus',
		type: 'text',
	},
];
